import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export const GenericModal = ({ show, handleClose, title, children, footerActions, handleSave, createConfig="" }) => {
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {children}
            </Modal.Body>
            <Modal.Footer>
                {footerActions ? footerActions : (
                    <>
                        <Button variant="secondary" onClick={handleClose}>Close</Button>
                        <Button variant="primary" onClick={handleSave}>{`${createConfig || "Save Changes"}`}</Button>
                    </>
                )}
            </Modal.Footer>
        </Modal>
    );
};
